import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UserGroupState {
  id: string;
  name: string;
  isActive: boolean;
  supervisors?: any;
  props: {
    [key: string]: any;
  };
}

const initialState: UserGroupState = {
  id: '',
  name: '',
  isActive: false,
  supervisors: [],
  props: { isModalVisible: false, refresh: false, searchTerm: '', skip: 1, take: 10, totalItems: 0 },
};

const userGroupSlice = createSlice({
  name: 'userGroup',
  initialState,
  reducers: {
    setUserGroup: (state, action: PayloadAction<Partial<UserGroupState>>) => {
      return { ...state, ...action.payload };
    },

    resetUserGroup: (_state, action: PayloadAction<Partial<UserGroupState['props']> | undefined>) => {
      return {
        ...initialState,
        props: { ...initialState.props, ...action.payload },
      };
    },

    updateField: (state: UserGroupState, action: PayloadAction<{ field: any; value: any }>) => {
      const { field, value } = action.payload;
      (state as any)[field] = value;
    },

    updateProps: (state, action: PayloadAction<{ field: string; value: any }>) => {
      const { field, value } = action.payload;
      state.props = {
        ...state.props,
        [field]: value,
      };
    },

    addSupervisors: (state, action) => {
      state.supervisors.push(action.payload);
    },

    updateSupervisors: (state, action: PayloadAction<{ index: number; updates: any }>) => {
      const { index, updates } = action.payload;
      if (state.supervisors[index]) {
        state.supervisors[index] = {
          ...state.supervisors[index],
          ...updates,
        };
      }
    },

    removeSupervisors: (state, action: PayloadAction<number>) => {
      if (state.supervisors) {
        state.supervisors.splice(action.payload, 1);
      }
    },
  },
});

export const {
  setUserGroup,
  resetUserGroup,
  updateField,
  updateProps,
  addSupervisors,
  updateSupervisors,
  removeSupervisors,
} = userGroupSlice.actions;

export default userGroupSlice.reducer;
